'use client';

import { useState } from 'react';
import {
  DoctorHeroSection,
  DoctorFeaturesSection,
  DoctorBenefitsSection,
} from '../doctors';
import { ContactFormDialog } from '../contact';

/**
 * @group Public
 * @summary Doctors page component
 * 
 * Page for doctors interested in joining the Phila platform.
 * Includes contact form dialog for clinician applications.
 */
export function DoctorsPage() {
  const [isContactDialogOpen, setIsContactDialogOpen] = useState(false);

  const handleJoinAsClinician = () => {
    setIsContactDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsContactDialogOpen(false);
  };

  return (
    <main className="min-h-screen">
      {/* Hero section with clinician application CTA */}
      <DoctorHeroSection onJoinAsClinician={handleJoinAsClinician} />
      
      {/* Features - Reducing Burnout, Protecting Autonomy */}
      <DoctorFeaturesSection />
      
      {/* Benefits - Scheduling, Dashboard, Support */}
      <DoctorBenefitsSection />
      
      {/* Contact Form Dialog */}
      <ContactFormDialog
        isOpen={isContactDialogOpen}
        onClose={handleCloseDialog}
        formType="clinician"
      />
    </main>
  );
}
